<template>
    <reconciliation-step-template
        :nextStep="false"
        :previousStep="false"
        :loading="loading"
        @previous="$emit('previous')"
    >
        <template #header> &nbsp; </template>
        <template #content>
            <div class="wp-6 m-auto acenter">
                <i class="icon-email-statut-valid success-50 fs-131"></i>
                <p class="fs-4 semibold mt-6">
                    {{
                        $l10n.__(
                            'Votre fichier a été correctement configuré, il sera disponible dans quelques instants sur votre outil de rapprochement bancaire.',
                        )
                    }}
                </p>
                <CompassButton
                    :label="$t.__('common.actions.continue')"
                    type="primary"
                    class="mt-3"
                    @click="next"
                />
            </div>
        </template>
        <template #footer> &nbsp; </template>
    </reconciliation-step-template>
</template>

<script>
import ReconciliationStepTemplate from './ReconciliationStepTemplate.vue';
export default {
    components: {
        ReconciliationStepTemplate,
    },
    data() {
        return {
            loading: true,
        };
    },
    computed: {
        idImport() {
            return this.$route.params.importid;
        },
    },
    methods: {
        next() {
            window.location.href = '/?_f=bankreconciliation_transactions';
        },
    },
};
</script>

<style scoped>
.fs-131 {
    font-size: 131px;
}
</style>
